import { render, staticRenderFns } from "./app-prso.vue?vue&type=template&id=59f165aa&scoped=true&"
import script from "./app-prso.vue?vue&type=script&lang=ts&"
export * from "./app-prso.vue?vue&type=script&lang=ts&"
import style0 from "./app-prso.vue?vue&type=style&index=0&id=59f165aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f165aa",
  null
  
)

export default component.exports